<div class="card flex justify-content-center">
  <p-sidebar #sidebarRef [(visible)]="sidebarVisible">
    <ng-template pTemplate="headless">
      <div class="flex flex-column">
        <div
          class="flex align-items-center justify-content-between px-4 pt-3 flex-shrink-0"
        >
          <span class="inline-flex align-items-center gap-2">
            <img alt="" src="assets/img/logo_cristalia_short.png" width="130" />
          </span>
          <span>
            <p-button
              (onClick)="closeCallback($event)"
              icon="pi pi-times"
              outlined="true"
              rounded="true"
              severity="info"
              styleClass="h-2rem w-2rem"
              type="button"
            ></p-button>
          </span>
        </div>
        <div class="overflow-y-auto">
          <ul class="list-none p-3 m-0">
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/categories"
              >
                <i class="pi pi-tag mr-2"></i>
                <span class="font-medium">Categorias</span>
              </a>
            </li>
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/sectors"
              >
                <i class="pi pi-chart-pie mr-2"></i>
                <span class="font-medium">Setores</span>
              </a>
            </li>
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/cycles"
              >
                <i class="pi pi-bullseye mr-2"></i>
                <span class="font-medium">Ciclos</span>
              </a>
            </li>
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/product-potential"
              >
                <i class="pi pi-palette mr-2"></i>
                <span class="font-medium">Produtos Potenciais</span>
              </a>
            </li>
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/proceedings"
              >
                <i class="pi pi-forward mr-2"></i>
                <span class="font-medium">Procedimentos</span>
              </a>
            </li>
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/profile"
              >
                <i class="pi pi-lightbulb mr-2"></i>
                <span class="font-medium">Perfil</span>
              </a>
            </li>
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/client"
              >
                <i class="pi pi-briefcase mr-2"></i>
                <span class="font-medium">Clientes</span>
              </a>
            </li>
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/contracts"
              >
                <i class="pi pi-file mr-2"></i>
                <span class="font-medium">Contratos</span>
              </a>
            </li>
            <li>
              <a
                pRipple
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                routerLink="/usuarios"
              >
                <i class="pi pi-user mr-2"></i>
                <span class="font-medium">Usuários</span>
              </a>
            </li>
            <li>
              <a
                pRipple
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                routerLink="/reports"
              >
                <i class="pi pi-chart-bar mr-2"></i>
                <span class="font-medium">Relatórios</span>
              </a>
            </li>
            <li>
              <a
                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple no-underline"
                pRipple
                routerLink="/contacts"
              >
                <i class="pi pi-address-book mr-2"></i>
                <span class="font-medium">Contatos</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
  </p-sidebar>
</div>
